import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import InsumosAll from './components/InsumosAll';

export default function index() {
  return (
    <>
      <MainContent
        titulo='Administración de Insumos'
        component={<InsumosAll />}
        tableMaxWidth
      />
      
      <Outlet />
    </>
  );
}